import firebase from 'firebase';
  
const firebaseConfig = {
    apiKey: "AIzaSyDo17TzJei-TGbH9OJNHyCtpMOxMQ0dXkg",
    authDomain: "gto-moscow-sport.firebaseapp.com",
    projectId: "gto-moscow-sport",
    storageBucket: "gto-moscow-sport.appspot.com",
    messagingSenderId: "904059961011",
    appId: "1:904059961011:web:f04f9fa27a86c35b88bac6"
};
  
firebase.initializeApp(firebaseConfig);
let auth = firebase.auth();
let db = firebase.firestore();
export {auth ,db, firebase};